import { firstToLowerCase } from '../../common/utils/helper';
import { TechnicalAnalysis } from './indicator-base';
/**
 * `SmaIndicator` module is used to render SMA indicator.
 */
export class SmaIndicator extends TechnicalAnalysis {
    /**
     * Defines the predictions based on SMA approach
     *
     * @private
     */
    initDataSource(indicator, chart) {
        const smaPoints = [];
        const points = indicator.points;
        if (points && points.length) {
            //prepare data
            const validData = points;
            const field = firstToLowerCase(indicator.field);
            const xField = 'x';
            const signalSeries = indicator.targetSeries[0];
            if (validData && validData.length && validData.length >= indicator.period) {
                //find initial average
                let average = 0;
                let sum = 0;
                for (let i = 0; i < indicator.period; i++) {
                    sum += validData[i][field];
                }
                average = sum / indicator.period;
                smaPoints.push(this.getDataPoint(validData[indicator.period - 1][xField], average, validData[indicator.period - 1], signalSeries, smaPoints.length));
                let index = indicator.period;
                while (index < validData.length) {
                    sum -= validData[index - indicator.period][field];
                    sum += validData[index][field];
                    average = sum / indicator.period;
                    smaPoints.push(this.getDataPoint(validData[index][xField], average, validData[index], signalSeries, smaPoints.length));
                    index++;
                }
            }
            this.setSeriesRange(smaPoints, indicator);
        }
    }
    /**
     * To destroy the SMA indicator
     *
     * @returns {void}
     * @private
     */
    destroy() {
        /**
         * Destroys the SMA indicator
         */
    }
    /**
     * Get module name.
     */
    getModuleName() {
        /**
         * Returns the module name of the series
         */
        return 'SmaIndicator';
    }
}
